import { useState } from "react";
import LowPriceIcon from "~/assets/home-icons/just-in-section/LowPriceIcon";
import MiddlePriceIcon from "~/assets/home-icons/just-in-section/MiddlePriceIcon";
import MiddleToTopPriceIcon from "~/assets/home-icons/just-in-section/MiddleToTopPriceIcon";
import TopPriceIcon from "~/assets/home-icons/just-in-section/TopPriceIcon";
import { getCurrencyValue } from "~/lib/utils";
import { CustomerMetafields, ProductMetafields, ShopSettings, VariantEdgeMetafields } from "~/types";
import QuoteButton from "./QuoteButton.client";
import RequestCustomizationFrom from "./RequestCustomizationFrom.client";
import { RequestPriceForm } from "./RequestPriceForm.client";
import { activeAffirmApp, askAQuestionForm, bigFurnitureShow, customize, digitalagent, disabledAddToBasket, myRegistryApp, paymentJustNow, paymentJustNowQuota, quantityCustom, sectionAskAQuestion, showNameRange, wishlistButton, customProductRequestForm, leadtime, brandPhoneNumberAvailable, wishlistButtonNextTitle, klarnaMessaging, setupCustomFinance, availabilityOptionsOnProductInfo, showPriceSaleWithDetailText, isBrochure, stockRequestInfo, inStockReadyToDeliver } from "../../../../setup/settings/__product";
import ShopifyCallouts from "../callouts/ShopifyCallouts.client";
import AskQuestionForm from "../AskQuestionForm.client";
import { customizeModalButton } from "../../../../setup/settings/__product";
import ArrowRightIcon from "~/assets/icons/ArrowRightIcon";
import WishlistButton from "~/rs-components/wishlist/WishListButton.client";
import Visit from "~/assets/icons/Visit";
import Call from "~/assets/icons/Call";
import Contacts from "~/assets/icons/Contact";
import PayJustNow from "~/rs-components/PayJustNow";
import VariantDetails from "../variant/VariantDetails.client";
import SettingsIcon from "~/assets/icons/SettingsIcon";
import useShopSettings from "~/rs-components/shop/useShopSettings";
import { isNonTransactional, showPriceshowPriceTransactional } from "../../../../setup/settings/__nonTransactional";
import AffirmPromotion from "../AffirmPromotion.client";
import MyRegistryButton from "./MyRegistryButton.client";
import RedirectUrlButton from "./RedirectUrlButton.client";
import { addToBasketButtonName } from "../../../../setup/settings/__cart";
import AccountPhone from "~/assets/icons/AccountPhone";
import KlarnaMessage from "../KlarnaMessage.client";
import SetupCustomFinance from "../../../../setup/components/setup/productDetail/SetupCustomFinance.client";
import FabricType from "~/assets/icons/FabricType";
import LeatherType from "~/assets/icons/LeatherType";
import ProductPriceDetailWithText from "./ProductPriceDetailWithText.client";
import SetupSectionAskAQuestion from "../../../../setup/components/setup/productDetail/SetupSectionAskAQuestion.client";
import TickIcon from "~/assets/icons/TickIcon";

type ProductInfoProps =
    {
        show: boolean,
        product: ProductMetafields,
        featuredProducts: any,
        shopSettings: ShopSettings,
        currency: string,
        setShowCustomize: (b: boolean) => void,
        setVariant: (v: VariantEdgeMetafields | undefined) => void,
        setSelectedVariant: (v: string) => void,
        selectedVariant: string,
        onAddToBasket: (quantity: number) => void,
        customer: CustomerMetafields,
        setModalType: (value: number) => void,
        isStock: boolean,
        variants: VariantEdgeMetafields[],
        variantDefault: VariantEdgeMetafields[],
    }

export default function ProductInfo({ customer, show, product, featuredProducts, shopSettings, currency,
    setShowCustomize, setVariant, setSelectedVariant, selectedVariant, onAddToBasket, setModalType,
    isStock, variants, variantDefault }: ProductInfoProps) {

    const multiplierQuantity: number = quantityCustom.visible && product.multiplierQuantity?.value != null ? parseInt(product.multiplierQuantity?.value) : 1;
    const minimumQuantity: number = quantityCustom.visible && product.minimumQuantity?.value != null ? parseInt(product.minimumQuantity?.value) : 1;
    const [quantity, setQuantity] = useState<number>(minimumQuantity > multiplierQuantity ? minimumQuantity : multiplierQuantity);
    const askforprice = JSON.parse(product.customField?.value ?? 'false').callforprice ?? 'false';
    const priceicon = JSON.parse(product.customField?.value ?? 'false').pricelevel ?? 'false';
    const disableButton = product.customField?.value != null ? JSON.parse(product.customField?.value).disableaddtocartbutton ?? false : false;
    const phone = JSON.parse(product.customField?.value ?? 'false').phone ?? 'false';
    const inLeather = (JSON.parse(product.customField?.value ?? 'true').inleather ?? false) === true;
    const inFabric = (JSON.parse(product.customField?.value ?? 'true').infabric ?? false) === true;

    const bulletpoints = product.customField?.value != null ? JSON.parse(product.customField?.value)?.bulletpoints ?? null : null;

    const { redPriceProduct, redPriceStock, askforpriceMessage,
        requestPrice, requestCustomization, hideBrandBreadcumb,
        hideProductRangeBreadcumb } = useShopSettings(shopSettings);

    const sumQuantity: () => void = () => {
        setQuantity(quantity + multiplierQuantity);
    }

    const substractQuantity: () => void = () => {
        const result: number = (quantity - multiplierQuantity);
        if (result > 0 && result >= minimumQuantity && result >= multiplierQuantity && result % multiplierQuantity == 0) setQuantity(result);
    }

    const toBasket: () => void = () => {
        if (!isDisabled()) {
            onAddToBasket(quantity);
        }
    }

    const clickCustomize: () => void = () => {
        // document.body.style.overflow = 'hidden';
        setVariant(undefined);
        setShowCustomize(true);
        setModalType(0);
    }

    const getIconPrice: () => JSX.Element | undefined = () => {
        if (priceicon == "TopPrice") {
            return <TopPriceIcon />;
        }
        if (priceicon == "MidToTopPrice") {
            return <MiddleToTopPriceIcon />
        }
        if (priceicon == "MidPrice") {
            return <MiddlePriceIcon />
        }
        if (priceicon == "LowPrice") {
            return <LowPriceIcon />
        }
    }

    const showPrice = (number = false) => {

        if (isNonTransactional && !showPriceshowPriceTransactional) return;

        const variantPrice = variantDefault[0]?.node.price.amount;
        const priceRange = product.priceRange?.value != undefined ? JSON.parse(product.priceRange?.value ?? '') : '';
        const oldPrice = variantDefault[0]?.node.oldPrices?.value;

        if (priceicon != 'false' && !digitalagent)
            return (getIconPrice());

        if ((variantPrice == "0.00" || variantPrice == "0.0") && priceRange != '') {
            if (priceRange[0] == priceRange[1])
                if (number) return priceRange[0]
                else return (
                    <p className={`${isStock && redPriceStock ? "ProductList__price-red" : ""}  product-info-price`}>{getCurrencyValue(currency, priceRange[0])}</p>
                )

            else {
                if (number) return priceRange[1]
                return (
                    <p className={`${redPriceStock && isStock ? "ProductList__price-red" : ""} product-info-price`}>
                        {getCurrencyValue(currency, priceRange[0])} - {getCurrencyValue(currency, priceRange[1])}
                    </p>
                )
            }
        }

        else if (oldPrice == null || digitalagent)
            if (number) return variantPrice;
            else return (
                <p className={`${redPriceStock && isStock && "ProductList__price-red"}  product-info-price`}>
                    {getCurrencyValue(currency, variantPrice)}
                </p>
            )
        else
            if (number) return variantPrice;
            else return (
                <>
                    {showPriceSaleWithDetailText.enabled && getOldPrice(parseFloat(variantPrice), JSON.parse(oldPrice)[0]?.toFixed(2)) && (
                        <ProductPriceDetailWithText />
                    )}
                    <div>
                        <p className={`oldPrice_Detail`}> {getOldPrice(parseFloat(variantPrice), JSON.parse(oldPrice)[0]?.toFixed(2))} </p>
                        <p className={`nowPrice_Detail ${redPriceStock && isStock || redPriceProduct ? "ProductList__price-red" : ""}`}> {getCurrencyValue(currency, variantPrice)} </p>
                    </div>
                </>
            )
    }

    const getOldPrice = (now: number, old: number | undefined) => {
        if (old == undefined) return '';
        if (now >= old) return '';
        if (now == old) return '';
        if (old) return getCurrencyValue(currency, `${old}`);
    }

    const getAskForPrice = () => {
        if (askforprice && requestPrice) return <RequestPriceForm product={product} customForm={customProductRequestForm.custom} />
        else if (askforprice && requestCustomization) return <RequestCustomizationFrom />
        else if (askforprice && askforpriceMessage) return <p>{askforpriceMessage}</p>
    }

    const isDisabled = (() => {
        if (isStock && selectedVariant != undefined) return false;
        const variantPrice = variantDefault[0]?.node.price.amount;
        const priceRange = product.priceRange?.value != undefined ? JSON.parse(product.priceRange?.value ?? '') : '';

        if (((parseFloat(variantPrice) === 0 && priceRange !== '' && priceRange[0] === priceRange[1]) || disabledAddToBasket)) return true;
        else return false;
    })

    const prevUrl = () => {
        let prevUrl = document.referrer;
        if (prevUrl.indexOf(window.location.host) !== -1) {
            window.history.back();
        }
    }

    return (
        <div className="product-options lg:pl-32 lg:pr-24 md:px-10 sm:px-10">
            {customize.visibleBackToList &&
                <div className="backtolist">
                    <a className="back-to-list-button" onClick={() => prevUrl()}>
                        <span className="back-to-list-icon-arrow">
                            <ArrowRightIcon />
                        </span>
                        Back to List
                    </a>
                </div>
            }
            {brandPhoneNumberAvailable && phone != 'false' &&
                <div className="phone-container">
                    <AccountPhone />
                    <h3>Call {phone}</h3>
                </div>

            }
            <div className="product-title">
                <h1>{product.title}</h1>
                {(wishlistButtonNextTitle && !isBrochure) && <WishlistButton customer={customer} handle={product.handle} />}
            </div>

            {featuredProducts.length > 0 &&
                <>
                    <div className="breadcrumb cursor-pointer select-none">{featuredProducts[0].brand != null && !hideBrandBreadcumb && <a href={`/collections/${featuredProducts[0].brand.handle}/products`}>› {product.vendor}</a>}</div>
                    <div className="breadcrumb cursor-pointer select-none">{featuredProducts[0].product_range != null && !hideProductRangeBreadcumb && <a href={`/collections/${featuredProducts[0].product_range.handle}/products`}>› {showNameRange ? product.productType : "View entire range"}</a>}</div>
                </>
            }

            {availabilityOptionsOnProductInfo && (
                <div className="product-info-material-options">
                    {inFabric && <FabricType />}
                    {inLeather && <LeatherType />}
                    {inLeather && !inFabric && (
                        <p>Available in Leather</p>
                    )}
                    {!inLeather && inFabric && (
                        <p>Available in Fabric</p>
                    )}
                    {inLeather && inFabric && (
                        <p>Available in Leather and Fabric</p>
                    )}
                </div>
            )}

            <ShopifyCallouts product={product} settings={shopSettings}></ShopifyCallouts>
            {paymentJustNow && <PayJustNow price={pricePaymentJustNow()} />}

            {getAskForPrice()}

            {!askforprice && <>
                <div className={`price ${showPriceSaleWithDetailText.enabled ? "withText" : ""}`}>
                    <span>
                        {showPrice()}
                    </span>
                    {wishlistButton.showInDetail && <WishlistButton customer={customer} handle={product.handle} />}
                    {product.customField?.value && JSON.parse(product.customField.value)?.leadtime && (
                        <p>{leadtime.text} : {JSON.parse(product.customField.value).leadtime}</p>
                    )}
                </div>
                {bulletpoints != null &&
                    <div className="bulletpoints"
                        dangerouslySetInnerHTML={{ __html: bulletpoints }}>
                    </div>
                }
                {activeAffirmApp.show && <AffirmPromotion price={showPrice(true) * 100} />}
                {
                    (inStockReadyToDeliver.enable && isStock) &&  <p className="inStock-ready-to-deliver">{<TickIcon color="#92C25F" />}{inStockReadyToDeliver.text}</p>
                }
                <VariantDetails
                    variants={variants}
                    setVariant={setVariant}
                    setSelectedVariant={setSelectedVariant}
                    selectedVariant={selectedVariant}
                    setShowCustomize={setShowCustomize}
                    redPriceStock={redPriceStock}
                    currency={currency}
                    setModalType={setModalType}
                />
                {quantityCustom.messageUnit &&
                    <span className="message-price-unit">
                        The price is per unit
                    </span>
                }
                {product.customizeOptions?.value &&
                    <span className="customize-button" onClick={clickCustomize}>
                        <span><SettingsIcon /></span>
                        {`${customizeModalButton.title}`}
                    </span>
                }
                {(isStock || !product.customizeOptions?.value) &&
                    <>
                        <QuoteButton disabled={isDisabled()} product={product} show={show} />
                        {!disableButton && (!isNonTransactional) &&
                            <>
                                {quantityCustom.visible &&
                                    <>
                                        {quantityCustom.messageMultiplier &&
                                            <p className="message-multiplier-quantity">
                                                This product must be purchased in lots of {multiplierQuantity} units.
                                            </p>
                                        }

                                        {quantityCustom.messageMininum &&
                                            <p className="message-minimum-quantity">
                                                The minimum order quantity for this product is {minimumQuantity} units.
                                            </p>
                                        }
                                        <div className="selectQuantity flex items-center border rounded">
                                            <button aria-label="Decrease quantity" onClick={() => substractQuantity()} className="w-10 h-10 transition hover:text-primary disabled:cursor-wait">−</button>
                                            <div className="px-2 text-center">{quantity}</div>
                                            <button aria-label="Increase quantity" onClick={() => sumQuantity()} className="w-10 h-10 transition hover:text-primary disabled:cursor-wait">+</button>
                                        </div>
                                    </>
                                }
                                {!isBrochure &&
                                    (!bigFurnitureShow &&
                                        <span className={`black-button ${isDisabled() && 'disabled'}`} onClick={() => toBasket()}>
                                            {addToBasketButtonName.default ? 'Add to Basket' : addToBasketButtonName.name}
                                        </span>
                                    )
                                }
                                <br />


                            </>
                        }
                    </>
                }
                {myRegistryApp.show && <MyRegistryButton product={product} showPrice={showPrice} />}
                {klarnaMessaging.show && <KlarnaMessage price={showPrice(true) * 100} />}
                {setupCustomFinance.enabled && <SetupCustomFinance product={product} price={showPrice(true) * 100} />}

            </>
            }
            {product?.redirectUrl && <RedirectUrlButton product={product} />}

            {askAQuestionForm.visible && <AskQuestionForm />}
            {sectionAskAQuestion && <SetupSectionAskAQuestion product={product} />}

            {product.descriptionBelowButton?.value != null
                ?
                <div className="product-description-below-button"
                    dangerouslySetInnerHTML={{ __html: product.descriptionBelowButton?.value }}>
                </div>
                :
                ""
            }
            {/* <span className="shop-secure">
                            <span><TickIcon /></span>
                            Shop secure. Free Returns
                        </span> */}
        </div>
    )

    function pricePaymentJustNow(): string {
        try {
            const price = (parseInt(variantDefault[0]?.node.price.amount) / paymentJustNowQuota).toFixed(2)
            return getCurrencyValue(currency, price)
        } catch (error) {
            return ""
        };
    }
}
